import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';
import { pageList, pageText } from '../../content/publicPages';
import { usePublicPage } from '../../hooks/usePublicPage';

/**
 * Shopify-style night band: thin headline + 3 photo story cards + ghost CTA.
 */
const MarketingAudienceBand = () => {
  const { saved, defaults } = usePublicPage('home');
  const stories = pageList(saved.audience_cards, defaults.audience_cards);
  return (
    <section className="bg-m-night px-4 py-20 text-m-on-dark sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto w-full max-w-6xl">
        <h2 className="marketing-section-title mb-12 max-w-3xl text-m-on-dark sm:mb-16">
          {pageText(saved.audience_title, defaults.audience_title)}
        </h2>

        <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-6 lg:gap-8">
          {stories.map((story) => (
            <article key={story.title} className="flex flex-col">
              <Link
                to={story.href}
                className="group relative mb-5 block overflow-hidden rounded-2xl"
              >
                <img
                  src={story.image}
                  alt=""
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                  loading="lazy"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/35 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              </Link>
              <h3 className="mb-2 text-lg font-medium tracking-tight text-m-on-dark">
                {story.title}
              </h3>
              <p className="marketing-body text-white/65">{story.body}</p>
            </article>
          ))}
        </div>

        <div className="mt-14 flex justify-center sm:mt-16">
          <Link to={pageText(saved.audience_cta_link, defaults.audience_cta_link)} className="marketing-btn marketing-btn-ghost gap-2">
            {pageText(saved.audience_cta_label, defaults.audience_cta_label)}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingAudienceBand;
